import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';
import {
  IconCalculator,
  IconBook,
  IconPackage,
  IconBan,
} from '@tabler/icons-react';

export const ReadyWhenYouAre = () => {
  const resources = [
    {
      icon: IconCalculator,
      title: 'Debris Calculator',
      description:
        "Figure out what size RED-E-BIN Dumpster you'll need using our calculator.",
      link: '/debris-calculator',
    },
    {
      icon: IconBook,
      title: 'Helpful Tips',
      description:
        'See the RED-E-BIN delivery and pickup process (spoiler alert: we make it simple for you).',
      link: '/dumpster-rental-guide',
    },
    {
      icon: IconPackage,
      title: 'Bin Sizes',
      description:
        'RED-E-BINS Dumpsters come in 8x4x4 and 10x5x5 sizes. Find out which fits your project.',
      link: '/dumpster-sizes',
    },
    {
      icon: IconBan,
      title: "Do's & Don'ts",
      description:
        "Find out what's ok and not ok to put in your RED-E-BIN Dumpster.",
      link: '/prohibited-items',
    },
  ];

  return (
    <section className="py-16 bg-white border-t-4 border-[#E31837]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-12 italic text-center">
            RED-E When You Are!
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {resources.map((resource, index) => {
              const IconComponent = resource.icon;
              return (
                <Link
                  key={index}
                  href={resource.link}
                  className="text-center group"
                >
                  <div className="flex justify-center mb-4">
                    <IconComponent
                      size={48}
                      stroke={1.5}
                      className="text-[#E31837]"
                    />
                  </div>
                  <h3 className="text-lg font-semibold text-[#E31837] mb-3 italic group-hover:underline">
                    {resource.title}
                  </h3>
                  <p className="text-sm text-[#333333] leading-relaxed">
                    {resource.description}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

